(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__videoTestimonialsBound) return;
    window.__videoTestimonialsBound = true;

    function setPlaying(item, playing) {
      item.classList.toggle('is-playing', playing);

      var button = item.querySelector('[data-video-testimonial-play]');
      if (!button) return;

      var label = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
      if (label) button.setAttribute('aria-label', label);
    }

    function pauseIframe(iframe) {
      if (!iframe || !iframe.contentWindow) return;

      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
        '*'
      );
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
    }

    function playIframe(iframe) {
      if (!iframe) return;

      if (iframe.src) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'playVideo', args: [] }),
          '*'
        );
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        return;
      }

      if (iframe.dataset.src) iframe.src = iframe.dataset.src;
    }

    function pauseItem(item) {
      setPlaying(item, false);

      var video = item.querySelector('[data-video-testimonial-native]');
      if (video) video.pause();

      pauseIframe(item.querySelector('[data-video-testimonial-iframe]'));
    }

    function pauseOthers(current) {
      document.querySelectorAll('[data-video-testimonial-item].is-playing').forEach(function (item) {
        if (item !== current) pauseItem(item);
      });
    }

    function playItem(item) {
      pauseOthers(item);
      setPlaying(item, true);

      var video = item.querySelector('[data-video-testimonial-native]');
      if (video) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
        return;
      }

      playIframe(item.querySelector('[data-video-testimonial-iframe]'));
    }

    document.addEventListener('click', function (event) {
      var play = event.target.closest('[data-video-testimonial-play]');
      if (!play || play.disabled) return;

      var item = play.closest('[data-video-testimonial-item]');
      if (!item) return;

      if (item.classList.contains('is-playing')) {
        pauseItem(item);
        return;
      }

      playItem(item);
    });

    document.addEventListener(
      'ended',
      function (event) {
        if (!event.target.matches || !event.target.matches('[data-video-testimonial-native]')) return;
        var item = event.target.closest('[data-video-testimonial-item]');
        if (item) setPlaying(item, false);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
